
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  template: `
  <a class='shopping-cart-menu-button flex flex-align-center flex-justify-center'
    :href='url'
    title='cart'>
    <i class='icons8-shopping-cart'></i> <shopping-cart-items-count />
  </a>
  `
})

export default class ShoppingCartMenuButton extends Vue {
  @Prop({ default: '' }) url: string

  mounted(): void {
    this.$store.dispatch('cart/getShoppingCartCount')
  }
}
